import fetch from '@/util/fetch'


//获取导航菜单列表
export function getMenuList(option = {
    showLoading: true
  }) {
    return fetch(Object.assign({
      url: '/sys/menu/nav',
      method: 'get',
    }, option))
  }

  //获取菜单列表
export function getMenuALlList(option = {
  showLoading: true
}) {
  return fetch(Object.assign({
    url: '/sys/menu/list',
    method: 'get',
  }, option))
}
  


// WEBPACK FOOTER //
// ./src/api/menu.js